import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import useFetch from '../../../../Utilities/Hooks/useFetch';
import { SLIDER } from '../../../../Utilities/APIs';
import Image from '../../../Partials/Elements/Image/Image';

// import Banner from '../../../Assets/images/Banner1.png'

import "swiper/css";
import "swiper/css/pagination";
import './Slider.css'

function Slider() {
    const [data, loading] = useFetch(SLIDER, 'true')
    
    return (
        <section className='sc_home_slide'>
            <div className="container">
                <div className="home_slider">
                    <Swiper
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Pagination]}
                        className="mySwiper"
                    >
                        {data?.map((data) => (
                            <SwiperSlide key={data._id}>
                                <Image imgSrc={data.image} imgAlt='slider' />
                                {/* <img src={API_URL + data.image} alt="Banner" /> */}
                            </SwiperSlide>
                        ))}
                        {loading ? '...loading' : ''}
                    </Swiper>
                </div>
            </div>
        </section>
    )
}

export default Slider